import { useEffect, useState } from 'react';
import { clearLocalBoard, loadBoard } from './api/storage';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { AuthScreen } from './components/auth/AuthScreen';
import { AppShell } from './components/layout/AppShell';
import { AdminViewProvider, useAdminView } from './context/AdminViewContext';
import { AppProvider } from './context/AppContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BillingProvider } from './context/BillingContext';
import { LocationProvider } from './router/location';

function Board() {
  const admin = useAdminView();
  return (
    <>
      <AppShell />
      {admin?.open && admin.enabled ? <AdminDashboard /> : null}
    </>
  );
}

function Gate() {
  const { status, user } = useAuth();
  const [phase, setPhase] = useState('loading');
  const [savedBoard, setSavedBoard] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!user) return undefined;
    let cancel = false;
    setPhase('loading');
    loadBoard(user.id).then((result) => {
      if (cancel) return;
      if (result.error && !result.board) {
        setPhase('error');
        return;
      }
      clearLocalBoard();
      setSavedBoard(result.board ?? null);
      setPhase('ready');
    });
    return () => {
      cancel = true;
    };
  }, [user, attempt]);

  if (status !== 'authenticated' || !user) return <AuthScreen />;
  if (phase === 'error') return <AuthScreen boardError onRetry={() => setAttempt((value) => value + 1)} />;
  if (phase !== 'ready') return <AuthScreen waiting />;
  return (
    <AdminViewProvider enabled={user.role === 'admin'}>
      <AppProvider key={user.id} account={user} savedBoard={savedBoard}>
        <BillingProvider>
          <Board />
        </BillingProvider>
      </AppProvider>
    </AdminViewProvider>
  );
}

export default function App() {
  return (
    <LocationProvider>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </LocationProvider>
  );
}
